import type { ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';

/**
 * One number that matters, big, with the words that make it honest underneath.
 *
 * `tone` colours the number itself: a figure that is good news reads green, one that
 * needs a person reads red, and the rest read as ink.
 */
export function Stat({
  label,
  value,
  hint,
  tone = 'neutral',
  className,
}: {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  tone?: 'neutral' | 'ok' | 'warn' | 'danger' | 'accent';
  className?: string;
}) {
  const colour = {
    neutral: 'text-ink',
    ok: 'text-ok',
    warn: 'text-warn',
    danger: 'text-danger',
    accent: 'text-accent-2',
  }[tone];
  return (
    <div className={cn('bg-card border-line rounded-card shadow-card border px-5 py-4', className)}>
      <p className="text-ink-3 text-[12px] font-semibold tracking-[0.1em] uppercase">{label}</p>
      <p className={cn('font-display mt-1.5 text-[30px] leading-none font-semibold', colour)}>
        {value}
      </p>
      {hint ? <p className="text-ink-3 mt-2 text-[13px] leading-snug">{hint}</p> : null}
    </div>
  );
}
